import script from "./ContactPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactPage.vue?vue&type=script&setup=true&lang=ts"

import "./ContactPage.vue?vue&type=style&index=0&id=47a4d4d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47a4d4d3"]])

export default __exports__